export default "__VITE_ASSET__CBGF8h7s__"